
/**
 * 주문 타입
 */
export type OrderResponseOrderType = typeof OrderResponseOrderType[keyof typeof OrderResponseOrderType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderResponseOrderType = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  ONE_TIME: 'ONE_TIME',
} as const;
